import useFunctionContext from '/druid/internal/useFunctionContext';

export default function useScrollTo() {
  const { scrollTo } = useFunctionContext();

  return scrollTo;
}
